module.exports = __webpack_public_path__ + "static/img/news_top_06_1.b24611cc.jpeg";